/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import CardInfo from '../CardInfo';
import { isEmpty } from '../../../utils/object';
import getSiteConfig from '../../../utils/getSiteConfig';

class Infos extends React.Component {
    canModifyOrderInfoCard = (className = '') => {
        const title = (
            <>
                Orders That <span className="bold">Can</span> Be Modified
            </>
        );
        const body = (
            <>
                <ul className="no-margin-top">
                    <li>
                        To edit a section, click the <b>MODIFY</b> button.
                    </li>
                    <li>
                        Each order can be modified once. Edit all sections
                        before clicking <b>SUBMIT</b>.
                    </li>
                    <li>You’ll receive an email confirming your changes.</li>
                </ul>
                <div>Payment details cannot be edited online.</div>
            </>
        );
        return <CardInfo className={className} title={title} body={body} />;
    };

    cannotModifyOrderInfoCard = (className = '') => {
        const siteConfig = getSiteConfig();
        const phoneNumber = siteConfig.phoneNumber || '';
        const phoneNumberShort = siteConfig.phoneNumberShort || '';
        const orderServiceEmail = siteConfig['order-service-email'] || '';
        const title = (
            <>
                Orders That <span className="bold">Cannot</span> Be Modified
            </>
        );
        const body = (
            <div className="no-margin-top">
                <div>
                    <span className="error-color bold">
                        “This Order May No Longer Be Modified”
                    </span>{' '}
                    means that your order has been processed and is ready to be
                    shipped, in-transit, or out for delivery.
                </div>
                <div className="margin-top">
                    For further assistance,{' '}
                    {orderServiceEmail ? (
                        <a
                            className="link"
                            href={`mailto:${orderServiceEmail}`}
                        >
                            email us
                        </a>
                    ) : (
                        'email us'
                    )}{' '}
                    or call{' '}
                    <a
                        className="link whitespace-nowrap"
                        href={`tel:+${phoneNumberShort}`}
                    >
                        {phoneNumber}
                    </a>
                </div>
            </div>
        );
        return <CardInfo className={className} title={title} body={body} />;
    };

    render() {
        const { featureFlags } = this.props;
        const ENABLE_MMO =            !isEmpty(featureFlags)
            && featureFlags['is-account-mmo-enabled'] === true;
        const instructionClassName = !ENABLE_MMO ? 'display-none' : '';
        return (
            <>
                {this.canModifyOrderInfoCard(instructionClassName)}
                {this.cannotModifyOrderInfoCard(instructionClassName)}
            </>
        );
    }
}

Infos.defaultProps = {
    featureFlags: {},
};

Infos.propTypes = {
    featureFlags: PropTypes.object,
};

export default Infos;
